import React from "react";

const PATHS = {
  gift: (
    <>
      <rect x="6" y="13" width="20" height="13" rx="1" stroke="currentColor" strokeWidth="1.3" />
      <rect x="4" y="9" width="24" height="5" rx="1" stroke="currentColor" strokeWidth="1.3" />
      <path d="M16 9v17" stroke="currentColor" strokeWidth="1.1" />
      <path d="M16 9c-1.5-3-6-4.5-7.5-2C7 9.3 10 9 16 9Z" stroke="currentColor" strokeWidth="1.1" strokeLinejoin="round" />
      <path d="M16 9c1.5-3 6-4.5 7.5-2C25 9.3 22 9 16 9Z" stroke="currentColor" strokeWidth="1.1" strokeLinejoin="round" />
    </>
  ),
  heart: (
    <path
      d="M16 27c-6-4.5-11-8.6-11-14.2C5 9 7.8 6 11.3 6c2 0 3.8 1 4.7 2.7C17 7 18.8 6 20.7 6 24.2 6 27 9 27 12.8 27 18.4 22 22.5 16 27Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
  ),
  star: (
    <path
      d="M16 5l3 8.5 9 .3-7.1 5.7 2.6 8.8L16 23l-7.5 5.3 2.6-8.8L4 13.8l9-.3L16 5Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
  ),
  welcome: (
    <>
      <path d="M9 27V6.5C9 5.7 9.7 5 10.5 5h9c.8 0 1.5.7 1.5 1.5V27" stroke="currentColor" strokeWidth="1.3" />
      <path d="M6 27h20" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <path d="M14 15h9M20 11.5l3.5 3.5-3.5 3.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  leaf: (
    <>
      <path d="M16 27C9 27 6 21 7 13c7-1 14 1 17 8 1.5 3.5 0 6-8 6Z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
      <path d="M8 14c6 3 11 7 14 12" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
    </>
  ),
  tag: (
    <>
      <path d="M6 6h11l11 11-13 13L4 19V8a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
      <circle cx="12" cy="12" r="2" stroke="currentColor" strokeWidth="1.2" />
    </>
  ),
  flex: (
    <>
      <path d="M6 26 26 6M26 6h-7M26 6v7" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 26h7M6 26v-7" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
};

function OccasionIcon({ icon, size = 32, color = "var(--gold-deep)", className = "" }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color }}
      role="img"
      aria-hidden="true"
    >
      {PATHS[icon]}
    </svg>
  );
}

export default OccasionIcon;
